import { useState, useCallback } from 'react';
import { changeCustomerState } from '../api/customers.api';

export function useChangeCustomerState() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const mutate = useCallback(async (customerId: string, newStateId: string) => {
    setIsLoading(true);
    setError(null);
    try {
      return await changeCustomerState(customerId, newStateId);
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || err?.message || 'Error changing customer state';
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    mutate,
    isLoading,
    error,
  };
}
